var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"file-format-icon",attrs:{"src":_vm.iconImg,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }